// extracted by mini-css-extract-plugin
export default {"wraper":"RecruitmentPost_wraper__GNGR2","title":"RecruitmentPost_title__A6BWM","text":"RecruitmentPost_text__vHl+c"};